import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';

@Injectable()
export class SfPayrollsProvider {

  private readonly _service: string = 'payroll';
  private readonly _model: string = 'SFPayrolls';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public getComponent(companyId: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getComponent';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof companyId !== 'undefined' && companyId !== null) _urlParams.companyId = companyId;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public getSptComp(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getSptComp';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};


    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public detailComponent(code: string, companyId: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'detailComponent';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof code !== 'undefined' && code !== null) _urlParams.code = code;
    if (typeof companyId !== 'undefined' && companyId !== null) _urlParams.companyId = companyId;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public updateComponent(params: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'updateComponent';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public newComponent(params: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'newComponent';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public deleteComponent(code: string, companyId: string): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'deleteComponent';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof code !== 'undefined' && code !== null) _urlParams.code = code;
    if (typeof companyId !== 'undefined' && companyId !== null) _urlParams.companyId = companyId;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getEmpPast(periodCode: any, payDate: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getEmpPast';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof payDate !== 'undefined' && payDate !== null) _urlParams.payDate = payDate;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getPastPayroll(params: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getPastPayroll';
    const _params: any = {};
    const _urlParams = {
      params: []
    };
    const _body: any = {};

    if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public getYearYtd(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getYearYtd';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public getTaxLocation(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getTaxLocation';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public editPastPayroll(params: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'editPastPayroll';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getTaxType(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getTaxType';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public getTotalComponent(companyId: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getTotalComponent';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof companyId !== 'undefined' && companyId !== null) _urlParams.companyId = companyId;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public getResignType(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getResignType';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public detailSchedule(periodCode: any, companyId: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'detailSchedule';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof companyId !== 'undefined' && companyId !== null) _urlParams.companyId = companyId;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public getWordList(companyId: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getWordList';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof companyId !== 'undefined' && companyId !== null) _urlParams.companyId = companyId;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public listEmpRecalculate(periodCode: any, paydate: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'listEmpRecalculate';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof paydate !== 'undefined' && paydate !== null) _urlParams.paydate = paydate;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public deletePayment(periodCode: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'deletePayment';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public taxstatus(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'taxstatus';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/sf-payroll/sf-payrolls.ts